
    import { Vue, Prop, Watch, Component } from "vue-property-decorator";
    import { Controlador as Model, ControladorInterfaz } from '../../controlador';
    import { Utiles } from '@/__env/pluggins/event-bus';
    import moment, { Moment } from 'moment';
    import { Wait } from '@/__env/ext';
    import { Contenido } from '@/__env/lib/Articulos/Contenido';
    @Component( {
        name: "Componente",
        props: {},
        components: {

        }
    } )
    export default class Componente extends Vue
    {
        @Prop()
        public Controlador: ControladorInterfaz;
        public get Articulo() { return this.Controlador.Articulo; }
        public get Estado() { return this.Controlador.Vista.Estado; }
        public Descripcion: string = '';
        public UltimaModificacion: Moment = null;
        @Prop()
        public Abierto: boolean;
        @Watch( 'Abierto' )
        onAbierto()
        {
            if ( this.Abierto && !this.Iniciado )
                this.Iniciar();
        }

        public Iniciado: boolean = false;
        public SeleccionarArchivo: boolean = false;
        public Guardando: boolean = false;
        public Cargando: boolean = false;

        protected Eventos: Function[] = [];
        beforeDestroy()
        {
            this.Eventos.forEach( x => x() );
        }


        async Iniciar()
        {
            this.Cargando = true;

            this.Descripcion = '';
            this.UltimaModificacion = null;

            if ( !this.Articulo )
                return;

            await Wait( 300 );
            let e = await this.Articulo.CargarContenido();
            if ( e )
            {
                this.Iniciado = true;
            }
            this.Cargando = false;
        }


        public async AgregarArchivo( archivo: File )
        {
            if ( !archivo )
                return;

            this.Guardando = true;
            await Wait( 100 );
            let ar = await this.Articulo.SubirContenido( archivo );
            if ( ar )
            {

            } else
            {
                this.$EventBus.Notificaciones.Error( 'Error al subir el archivo' );
            }
            this.Guardando = false;

        }

        Descargar( d: Contenido )
        {
            window.open( d.Archivo );
        }

        async Eliminar( d: Contenido )
        {

            if ( !await Utiles.Mensajes.SiNo( 'Eliminar archivo', '¿Está seguro?' ) )
                return;

            let ar = d.del();
            if ( ar )
            {
                this.Articulo.Contenidos.splice( this.Articulo.Contenidos.findIndex( x => x.Id = d.Id ), 1 );
                this.Refrescar();
            } else
            {
                this.$EventBus.Notificaciones.Error( 'Error al eliminar el archivo' );
            }

        }

        public Refresh: boolean = true;
        public Refrescar()
        {
            this.Refresh = false;
            this.$nextTick( () => this.Refresh = true );
        }

    }
